// Libelles lisibles des roles, partages par toutes les pages qui affichent un
// role a l'utilisateur (entetes de dashboard, historique des acteurs).
// Les clefs correspondent aux valeurs du champ `role` renvoye par l'API.
export const LABELS_ROLES = {
  demandeur:                'Demandeur',
  chef_projet:              'Chef de Projet',
  responsable:              'Responsable',
  responsable_service:      'Responsable de Service',
  acheteur:                 'Acheteur',
  direction_achats:         'Direction des Achats',
  preparateur_memo_filiale: 'Préparateur Mémo Filiale',
  dg_filiale:               'Directeur Général Filiale',
  preparateur_memo_holding: 'Préparateur Mémo Holding',
  assistante_pdg:           'Assistante PDG',
  pdg:                      'Président Directeur Général',
  admin:                    'Administrateur',
};

// Aiguillage apres connexion : chaque groupe a son tableau de bord.
// Les deux points d'entree (LoginPage et useDashboard) lisent ces memes listes,
// pour qu'un role ajoute ici soit route de facon identique partout.
export const ROLES_ACTEUR = [
  'acheteur',
  'direction_achats',
  'preparateur_memo_filiale',
  'dg_filiale',
  'preparateur_memo_holding',
  'responsable_service',
  'assistante_pdg',
  'responsable',
];

export const ROLES_DEMANDEUR = ['demandeur', 'chef_projet'];

// Roles qui apposent une signature, et peuvent donc la deleguer.
// Doit rester coherent avec ROLES_DELEGANTS dans
// backend/src/services/delegationService.js — le serveur reste seul juge.
export const ROLES_DELEGANTS = ['dg_filiale', 'pdg'];

// Acces aux analyses. Portee globale pour les trois premiers ; le DG de filiale
// y accede aussi, mais restreint a la sienne — la portee est recalculee cote
// serveur (analyticsService.PORTEE_PAR_ROLE), ceci ne fait qu'afficher l'entree.
export const ROLES_ANALYTICS_GLOBAL = ['admin', 'pdg', 'preparateur_memo_holding'];
export const ROLES_ANALYTICS = [...ROLES_ANALYTICS_GLOBAL, 'dg_filiale'];

export default LABELS_ROLES;
